module.exports = __webpack_public_path__ + "static/no-fees-806f8104144f686cf133bf9dca545af2.jpg";